module.exports = __webpack_public_path__ + "ef5cd6bd7039da824a00407b24f6034d.svg";